<template lang="html">
  <div id="email-floorplan" class="flex flex-column items-center justify-center" :class="{'isDesktop': !isTouchscreen}">
    <div class="content w-100">
      <div class="white pointer ml-auto mr4 absolute close-btn" @click="closeEmailFloorplan()">
        <i class="f3 black material-icons">close</i>
      </div>
      <div class="f3 black mv3 pt4 lato">
        <span v-if="emailList.length === 1">EMAIL <strong>{{ emailList[0].name }}</strong> TO YOUR INBOX</span>
        <span v-else>EMAIL ME THESE FLOORPLANS</span>
      </div>

      <div class="plans mv4 flex flex-row items-center justify-center karla black" v-if="emailList.length > 1">
        <div class="plan" v-for="plan in emailList" :class="{remove: !plan.favourited && mode === 'liked'}" :key="plan.id">
          <div class="details">
            <div class="title nowrap">
              <span class="name b black" v-html="plan.name"></span>
            </div>
            <div class="bed-type black">
              {{ getType(plan) }}
            </div>
            <div class="size black">
              {{ plan.interior }} sq.ft.
            </div>
            <div class="view">
              <button @click="selectPlan(plan)">view</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Email Input -->
      <div class="email center">
        <div class="dib relative">
          <input class="br2" :class="{'error': this.status.error}" v-model="postParams.email" placeholder="enter your email address" @keyup.enter.native="sendEmail" />
          <transition name="fade" mode="out-in">
            <span class='send-arrow' v-if="!sending" @click="sendEmail()">
              <i class="material-icons ml2 f2">keyboard_arrow_right</i>
            </span>
            <span v-else-if="sending && !status.message" class="material-icons spin">refresh</span>
          </transition>
        </div>

      </div>

      <transition name="fade">
        <div class="status" v-show="this.status.message" :class="{'error': this.status.error}">
          {{ this.status.message }}
        </div>
      </transition>

      <div class="clear tc">
        <div class="pointer dib mr3" @click="clearEmail()">Clear</div>
        <div class="pointer dib ml3" @click="closeEmailFloorplan()">Close</div>
      </div>

      <div class="keyboard mv5" v-show="isTouchscreen">
        <div class="row" v-for="(row, row_index) in keys" :key="row_index">
          <button type="button" name="button" class="key_btn" :id="key" :class="{'key': true, 'big_key': row_index === 0}" v-for="(key, index) in row" @click="keyClicked(key)" :key="key+index">
            <span v-if="key === 'backspace'" class="material-icons v-mid">arrow_back</span>
            <span v-else class="lato">{{ key }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-email-floorplan',
  data() {
    return {
      baseUrl: 'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
      dtkLogo: '/static/img/Landing/landing-logo.png',
      keys: [
        ['@gmail.com', '@outlook.com', '@live.com', '@yahoo.com'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'],
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '@'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '.'],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm', '-', '_']
      ],
      postParams: {
        email: '',
        email_title: 'The Keeley Floor Plan Interest',
        sender: 'do_not_reply@adhocstudio.ca',
        sender_name: 'The Keeley',
        contact: 'The Keeley',
        pdfPath: [],
        fpNames: [],
        emailMessage: `Thank you for visiting the Keeley sales centre!<br /><br />
          Attached are the floorplan(s) you were interested in today.<br /><br />
        `
      },
      sending: false,
      status: {
        error: false,
        message: ''
      },
      curPlans: [],
      mode: 'liked'
    };
  },
  methods: {
    ...mapActions({
      TOGGLE_EMAIL_FLOORPLANS: 'TOGGLE_EMAIL_FLOORPLANS',
      EMAIL_FLOORPLANS: 'EMAIL_FLOORPLANS'
    }),
    getType(plan) {
      switch (plan.type.slug) {
        case 'one': { return '1 Bedroom'; }
        case 'oneDen': { return '1 Bedroom + Den'; }
        case 'two': { return '2 Bedroom'; }
        case 'twoDen': { return '2 Bedroom + Den'; }
        case 'three': { return '3 Bedroom'; }
        case 'threeDen': { return '3 Bedroom + Den'; }
        default: { return 'Studio'; }
      }
    },
    inLikedPlans(plan) {
      return plan.favourited;
    },
    toggleLikePlan(plan) {
      this.TOGGLE_FAVOURITE_PLAN(plan.id);
    },
    closeEmailFloorplan() {
      this.postParams.email = '';
      this.status.error = false;
      this.status.message = '';

      this.TOGGLE_EMAIL_FLOORPLANS(false);
    },
    clearEmail() {
      this.postParams.email = '';
      this.status.error = false;
      this.status.message = '';
    },
    keyClicked(key) {
      switch (key) {
        case 'backspace':
          this.postParams.email = this.postParams.email.substr(0, this.postParams.email.length - 1);
          break;
        default:
          this.postParams.email += key;
      }
    },
    sendEmail() {
      this.status.message = '';
      if (!this.validEmail(this.postParams.email)) {
        this.status.error = true;
        this.status.message = 'Please enter a valid email address';
        return;
      }

      this.postParams.pdfPath.length = 0;
      this.postParams.pdfPath.push(...this.emailList.map(plan => plan.images.pdf.url));
      this.postParams.fpNames.length = 0;
      this.postParams.fpNames.push(...this.emailList.map(plan => plan.name));
      this.postParams.project_id = this.adhocId;

      this.sending = true;
      const postParams = Object.assign({}, this.postParams);
      postParams.email = [postParams.email];
      this.EMAIL_FLOORPLANS(postParams)
        .then((res) => {
          console.log(res);
          if (res.data.statusCode === 200) {
            this.status.error = false;
            this.status.message = 'Thank you. The floorplan(s) have been sent to your email.';
            setTimeout(() => {
              this.closeEmailFloorplan();
              this.sending = false;
              this.status.message = '';
              this.status.error = false;
            }, 5000, this);
          } else {
            this.sending = false;
            this.status.error = true;
            this.status.message = 'There was a problem connecting to the server. Please try again later.';
          }
        })
        .catch((e) => {
          console.log(e);
          this.sending = false;
          this.status.error = true;
          this.status.message = 'There was a problem connecting to the server. Please try again later.';
        });
    },
    validEmail(email) {
      /* eslint no-useless-escape: 0 */
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  computed: {
    ...mapGetters({
      adhocId: 'adhocId',
      emailList: 'emailList',
      isTouchscreen: 'isTouchscreen'
    }),
    favouritesNoDupes() {
      const noDupes = [];
      this.favourites.forEach((plan) => {
        const planExists = noDupes.filter(planNode => planNode.name === plan.name);
        if (planExists.length === 0) {
          noDupes.push(plan);
        }
      });
      return noDupes;
    }
  }
};
</script>

<style lang="scss" scoped>

#email-floorplan {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  overflow-y: auto;
  background-color: #ffffff;
  width: 100%;
  z-index: 999;

  .close-btn {
    right: 1%;
    top: 4%;
    &:hover { opacity: 0.7; }
    &:active { transform: scale(0.8); }
  }

  .content {
    padding-top: 0;

    .section_title {
      padding-bottom: 120px;
    }

    .plans {
      flex-wrap: wrap;

      .plan {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        text-align: left;
        padding-top: 16px;
        padding-bottom: 16px;

        margin: 0 15px;
        max-width: 320px;

        transition: all 0.5s ease-out;

        .img {
          width: 130px;
          height: 195px;
          text-align: center;
          background-color: #ffffff;
          background-blend-mode: multiply;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
        }

        .details {
          padding-left: 25px;
          font-size: 14px;
          line-height: 22px;
          color: #404041;

          .title {
            color: black;
            font-size: 24px;
            margin-bottom: 10px;

            span {
              margin-left: 5px;
              vertical-align: middle;

              &.name {
                margin-left: 0px;
              }
            }
          }

          .view button {
            // font-family: $chronicleDeck;
            background-color: #ffffff;
            color: white;
            border: none;
            width: 108px;
            height: 25px;
            padding-bottom: 2px;
            font-size: 14px;
            text-align: center;
            margin-top: 10px;
          }
        }

        &.remove {
          opacity: 0;
        }
      }
    }

    div.email {
      position: relative;
      margin-top: 30px;
      margin-bottom: 15px;

      input {
        width: 600px;
        max-width: 100%;
        height: 80px;
        padding-right: 3rem;
        border: 2px solid #000000;
        font-size: 18px;
        text-align: center;

        background-color: transparent;
        color: #000000;
        font-size: 33px;
        outline: none;

        &.error {
          border: 2px solid #cb1615;
        }

        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
          color: rgba(0, 0, 0, 0.3);
        }
      }

      span {
        position: absolute;
        right: 0%;
        top: 12px;
        padding: 13px 15px 13px 20px;
        display: inline-block;
        color: #000000;

        &.material-icons {
          font-size: 29px;
          animation: spin 1s linear infinite;
          height: 30px;
          width: 30px;
          padding: 0px;
          margin-right: 13px;
          margin-top: 13px;
        }

        &:active {
          transform: scale(0.9);
        }
      }
    }

    div.status {
      color: #000000;

      &.error {
        color: #cb1615;
      }
    }

    div.clear {
      margin-top: 15px;
      color: #000000;
      font-size: 14px;
      letter-spacing: 0.4px;

      div {

        &:active {
          transform: scale(0.9);
        }
      }
    }

    /* Keyboard */
    .keyboard {
      text-align: center;
    }

    button#backspace {
      width: 100px;
      span.ion-backspace {
        font-size: 20px;
        vertical-align: middle;
      }
    }

    .row > .key_btn {
      // font-family: $geomanist;
      display: inline-block;
      width: 55px;
      height: 55px;
      outline: none;
      color: #000000;
      border: 2px solid #000000;
      border-radius: 5px;

      font-size: 21px;
      line-height: 40px;
      margin-left: 5px;
      margin-right: 5px;
      background-color: transparent;
      text-align: center;
      text-transform: uppercase;
      font-size: 15px;
    }

    .row:first-of-type > .key_btn {
      text-transform: lowercase;
    }

    .key_btn {
      // font-family: $geomanist;
      margin: 0.2rem auto;
      text-align: center;
      font-size: 1.2rem;
      display: inline-block;
      height: 3.5rem;
      line-height: 3.5rem;
      vertical-align: middle;
      text-align: center;
      text-transform: capitalize;
      background-color: #ffffff;
      border: 1px solid #000000;
      outline: none;
    }

    .key_btn.big_key {
      width: 160px;
    }

    .key_btn:active {
      transform: scale(0.95);
      background-color: #000000;
      color: #ffffff;
    }

    .key_btn > .ion-ios-arrow-thin-left {
      font-size: 48px;
    }

    button.close {
      position: fixed;
      bottom: 30px;
      left: 50%;
      padding-right: 20px;
      padding-left: 20px;
      color: #ffffff;
      font-size: 14px;
      transform: translateX(-50%);

      &:active {
        transform: translateX(-50%) scale(0.9);
      }
    }

    .disclaimer {
      margin-top: 20px;
    }
  }

  &.isDesktop {
    .content {

      div.email {
        input {
          height: 60px !important;
          font-size: 16px !important;

          &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
            color: rgba(0, 0, 0, 0.5) !important;
          }
        }
      }

      span {
        cursor: pointer;
        top: 52.5% !important;
        transform: translateY(-50%);
        &:active {
          transform: scale(0.9) translateY(-55%) !important;
        }

        &.material-icons {
          top: 0 !important;
        }
      }

    }
  }

  @keyframes spin { 0% { transform: rotate(0deg); }
  100% { transform: rotate(359deg); } }
}
</style>



// WEBPACK FOOTER //
// src/components/EmailFloorplan.vue